// src/components/AppIcon.jsx
'use client';

import React from 'react';
import * as HeroIcons from '@heroicons/react/24/outline';
import * as HeroIconsSolid from '@heroicons/react/24/solid';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';

function Icon({
    name,
    variant = 'outline',
    size = 24,
    className = '',
    onClick,
    disabled = false,
    ...props
}) {
    const iconSet = variant === 'solid' ? HeroIconsSolid : HeroIcons;
    const IconComponent = iconSet?.[name];

    if (!IconComponent) {
        return (
            <QuestionMarkCircleIcon data-component-id="src/components/ui/AppIcon.jsx:24:12" data-component-path="src/components/ui/AppIcon.jsx" data-component-line="24" data-component-end-line="30" data-component-file="AppIcon.jsx" data-component-name="QuestionMarkCircleIcon" data-component-content="%7B%22elementName%22%3A%22QuestionMarkCircleIcon%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
                width={size}
                height={size}
                className={`text-gray-400 ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
                onClick={disabled ? undefined : onClick}
                {...props}
            />
        );
    }

    return (
        <IconComponent data-component-id="src/components/ui/AppIcon.jsx:35:8" data-component-path="src/components/ui/AppIcon.jsx" data-component-line="35" data-component-end-line="41" data-component-file="AppIcon.jsx" data-component-name="IconComponent" data-component-content="%7B%22elementName%22%3A%22IconComponent%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
            width={size}
            height={size}
            className={`${disabled ? 'opacity-50 cursor-not-allowed' : onClick ? 'cursor-pointer hover:opacity-80' : ''} ${className}`}
            onClick={disabled ? undefined : onClick}
            {...props}
        />
    );
}

Icon.propTypes = {
    name: PropTypes?.string?.isRequired,
    variant: PropTypes?.oneOf(['outline', 'solid']),
    size: PropTypes?.number,
    className: PropTypes?.string,
    onClick: PropTypes?.func,
    disabled: PropTypes?.bool,
};

export default Icon;